import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import { NavLink } from 'react-router-dom';
import { loginError, userLogin } from "../store/actions/authActions";
import { toggleModal } from "../store/actions/toggleModalActions";
import { signUpUser } from "../store/actions/usersActions";
import './LoginPage.scss';

import ButtonSpinner from "./_common/ButtonSpinner";
import ErrorModal from "./_common/ErrorModal";
import logo from '../assets/logo/logo_agronet.png';
import EnhancedErrorModal from "./_common/EnhancedErrorModal";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'

const selector = state => {
    return {
        disableButtons: state.disableButtons,
        modalState: state.modalState,
        authError: state.authError,
        t: state.language.translator
    };
};

const LoginPage = () => {

    const { t, disableButtons, modalState, authError } = useSelector(selector);
    const dispatch = useDispatch();
    const history = useHistory();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [signUpName, setSignUpName] = useState('');
    const [signUpEmail, setSignUpEmail] = useState('');
    const [signUpPhone, setSignUpPhone] = useState('');
    const [signUpPassword, setSignUpPassword] = useState('');
    const [signupLastName, setSignupLastName] = useState('');
    const [distributor, setDistributor] = useState(null);
    const [forgotPasswordModal, setForgotPasswordModal] = useState(false)

    const location = useLocation();

    const [isTabletOrLess, setIsTabletOrLess] = useState(checkScreenSize());
    function checkScreenSize() {
        const breakpoint = 932;
        return window.innerWidth <= breakpoint;
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const signup = searchParams.get('signup');
        const distributor = searchParams.get('distributor');

        if(signup) {
            toggleViews(modalState.flag)
        }
        if(distributor) {
            setDistributor(distributor)
        }

    }, [location.search]);

    const loginOnEnter = e => {
        if (e.keyCode === 13) {
            dispatch(userLogin(username, password, history))
        }
    };

    const toggleViews = flag => {
        setUsername('');
        setPassword('');
        setSignUpName('');
        setSignUpEmail('');
        setSignUpPhone('');
        setSignUpPassword('');
        setSignupLastName('');
        setForgotPasswordModal(false)
        dispatch(toggleModal(!flag, 'signUp'))
    };

    return (
        <div className='loginPage'>

            <div className='gradientBox'>
                <div className='gradientBoxColumn'>
                    <div className='gradientBoxTitle'>
                        {t.gettext('Don’t have an account?')}
                    </div>
                    <div className='gradientBoxInfo'>
                        {t.gettext('Fill your personal details and stay connected with us.')}
                    </div>
                    <button
                        className='gradientBoxButton'
                        onClick={() => toggleViews(modalState.flag)}
                    >
                        {t.gettext('Sign up')}
                    </button>
                </div>
                <div className='gradientBoxColumn'>
                    <div className='gradientBoxTitle'>
                        {t.gettext('Already have an account?')}
                    </div>
                    <div className='gradientBoxInfo'>
                        {t.gettext('Log in using your username and password.')}
                    </div>
                    <button
                        className='gradientBoxButton'
                        onClick={() => toggleViews(modalState.flag)}
                    >
                        {t.gettext('Log in')}
                    </button>
                </div>
            </div>

            <div
                className={modalState.flag && modalState.modal === 'signUp' ? 'loginWindow signUp' : 'loginWindow'}
                onKeyDown={loginOnEnter}
            >
                <img className={modalState.flag && modalState.modal === 'signUp' ? 'loginLogo loginLogo--signUp': 'loginLogo'} src={logo} alt='App logo' />

                <div className="loginFormTitle">
                    {modalState.flag && modalState.modal === 'signUp'
                        ? t.gettext('Sign up')
                        : forgotPasswordModal ? t.gettext('Forgot your password') : t.gettext('Log in')}
                </div>

                {/*<div id='loginErrorMessage' className='loginErrorMessage'>*/}
                {/*    {authError && (!modalState.flag && modalState.modal !== 'signUp') &&*/}
                {/*        t.gettext('Authorization failed. Please try again.')*/}
                {/*    }*/}
                {/*</div>*/}

                {authError && (!modalState.flag && modalState.modal !== 'signUp') &&
                    <EnhancedErrorModal
                        error={t.gettext('Incorrect Email or password')}
                        closeMethod={() =>  dispatch(loginError(''))}
                        closeText={t.gettext('Try Again')}
                    />
                }

                {modalState.flag && modalState.modal === 'signUp'
                    ? <form className='loginForm'>
                        <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            <div style={{width: '45%'}} className='loginFormItem'>
                                <label className='loginFormLabel'>
                                    {t.gettext('Name')}
                                </label>
                                <input
                                    className='loginFormSignupInput'
                                    value={signUpName}
                                    onInput={e => {
                                        setSignUpName(e.target.value);
                                    }}
                                    type='text'
                                />
                            </div>
                            <div style={{width: '45%'}} className='loginFormItem'>
                                <label className='loginFormLabel'>
                                    {t.gettext('Last Name')}
                                </label>
                                <input
                                    className='loginFormSignupInput'
                                    value={signupLastName}
                                    onInput={e => {
                                        setSignupLastName(e.target.value);
                                    }}
                                    type='text'
                                />
                            </div>
                        </div>

                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Email')}
                            </label>
                            <input
                                className='loginFormSignupInput'
                                value={signUpEmail}
                                onInput={e => {
                                    setSignUpEmail(e.target.value);
                                }}
                                type='email'
                            />
                        </div>
                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Password')}
                            </label>
                            <input
                                className='loginFormSignupInput'
                                value={signUpPassword}
                                onInput={e => {
                                    setSignUpPassword(e.target.value);
                                }}
                                type='password'
                            />
                        </div>
                        <div className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Phone number')}
                            </label>
                            <div style={{marginTop: '10px'}}>
                                <PhoneInput
                                    country={'pl'}
                                    value={signUpPhone}
                                    regions={'europe'}
                                    onChange={phone => setSignUpPhone(phone)}
                                    inputStyle={{
                                        width: "100%",
                                        height: '40px'
                                    }}
                                />
                            </div>

                            {/*<input*/}
                            {/*    className='loginFormSignupInput'*/}
                            {/*    value={signUpPhone}*/}
                            {/*    onInput={e => {*/}
                            {/*        setSignUpPhone(e.target.value);*/}
                            {/*    }}*/}
                            {/*    type='number'*/}
                            {/*/>*/}
                        </div>
                        <div className='loginButtonHolder'>
                            <button
                                className={!signUpName || !signUpEmail || !signUpPassword ? 'loginButton loginButton--disabled' : 'loginButton'}
                                onClick={e => {
                                    e.preventDefault();
                                    dispatch(signUpUser(signUpName, signUpEmail, signUpPhone, signUpPassword, distributor, signupLastName))
                                }}
                                disabled={!signUpName || !signUpEmail || !signUpPassword}
                            >
                                {t.gettext('Sign up')}
                            </button>
                            {isTabletOrLess && (
                                <>
                                    <div className="mobileTxtWrapper">
                                        <div className='mobileTxtTitle'>
                                            {t.gettext('Already have an account?')}
                                        </div>
                                        <div className='mobileTxtInfo'>
                                            {t.gettext('Log in using your username and password.')}
                                        </div>
                                    </div>
                                    <button
                                        className='loginButton loginButton--reverse'

                                        onClick={() => toggleViews(modalState.flag)}
                                    >
                                        {t.gettext('Log in')}
                                    </button>
                                </>

                            )}
                        </div>
                    </form>
                    :
                    forgotPasswordModal
                        ? <form action="" className="loginForm">
                            <div className="forgotPasswordSubtitle">
                                {t.gettext('Enter your registered Email Address here.')}
                            </div>
                            <div className='loginFormItem'>
                                <label className='loginFormLabel'>
                                {t.gettext('Email')}
                                 </label>
                                 <input
                                     className='loginFormInput'
                                     value={username}
                                     // onInput={e => {
                                     //     setUsername(e.target.value);
                                     //     dispatch(loginError(''))
                                     // }}
                                     type='email'
                                 />
                             </div>
                             <div className='loginButtonHolder'>
                                 <button
                                     className='loginButton'
                                     onClick={() => setForgotPasswordModal(false)}
                                     // onClick={() => dispatch(userLogin(username, password, history))}
                                     // disabled={disableButtons || !username || !password}
                                 >
                                     {t.gettext('Send link')}
                                     {disableButtons && <ButtonSpinner black/>}
                                 </button>
                             </div>
                         </form>
                         :
                         <form className='loginForm'>
                             <div className='loginFormItem'>
                                 <label className='loginFormLabel'>
                                     {t.gettext('Login')}
                                 </label>
                                 <input
                                     className='loginFormInput'
                                     value={username}
                                     onInput={e => {
                                         setUsername(e.target.value);
                                         dispatch(loginError(''))
                                     }}
                                     type='email'
                            />
                        </div>
                        <div style={{marginBottom: '12px'}} className='loginFormItem'>
                            <label className='loginFormLabel'>
                                {t.gettext('Password')}
                            </label>
                            <input
                                className='loginFormInput'
                                value={password}
                                onInput={e => {
                                    setPassword(e.target.value);
                                    dispatch(loginError(''))
                                }}
                                type='password'
                            />
                        </div>
                        <div className="policiesWrapper">
                            <div>
                                <NavLink className='linkToDocument' exact to='/terms_and_conditions'>{t.gettext('Terms & Conditions')}</NavLink>
                                <NavLink className='linkToDocument' exact to='/privacy_policy'>{t.gettext('Privacy Policy')}</NavLink>
                            </div>
                            <div>
                                {!isTabletOrLess && (
                                    <span onClick={() => setForgotPasswordModal(true)}
                                          className="linkToDocument">{t.gettext('Forgot password?')}</span>
                                )}
                            </div>
                        </div>

                             <div className='loginButtonHolder'>
                            <button
                                className='loginButton'
                                onClick={() => dispatch(userLogin(username, password, history))}
                                disabled={disableButtons || !username || !password}
                            >
                                {t.gettext('Log in')}
                                {disableButtons && <ButtonSpinner black/>}
                            </button>
                                 {isTabletOrLess && (
                                     <>
                                         <div className="mobileTxtWrapper">
                                             <div className='mobileTxtTitle'>
                                                 {t.gettext('Don’t have an account?')}
                                             </div>
                                             <div className='mobileTxtInfo'>
                                                 {t.gettext('Fill your personal details and stay connected with us.')}
                                             </div>
                                         </div>
                                         <button
                                             className='loginButton loginButton--reverse'

                                             onClick={() => toggleViews(modalState.flag)}
                                         >
                                         {t.gettext('Sign up')}
                                         </button>
                                     </>

                                 )}
                             </div>
                         </form>
                }
                {modalState.flag && modalState.modal === 'signUpComplete' &&
                    <ErrorModal
                        error={t.gettext('Sign up request has been sent')}
                        closeMethod={() => dispatch(toggleModal(false, ''))}
                    />
                }
                {modalState.flag && modalState.modal === 'signUpFailed' &&
                    <ErrorModal
                        error={t.gettext('Sign up failed')}
                        requestFailed
                        closeMethod={() => dispatch(toggleModal(false, ''))}
                    />
                }
            </div>
        </div>
    );
};

export default LoginPage;

